import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import DatePicker from 'react-datepicker2';

export default class Applicant extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
        };
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/applicant/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/applicant/save", {
            id: this.state.id,
            name: this.state.data.record.name,
            nationalId: this.state.data.record.nationalId,
            phone: this.state.data.record.phone,
            servicePrice: this.state.data.record.servicePrice,
            labName: this.state.data.record.labName,
            description: this.state.data.record.description,
            date: this.convertMomentToDb(this.state.data.record.date),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات مشتری" : "افزودن مشتری جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">نام</label>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">کدملی</label>
                                            <input defaultValue={this.state.data.record.nationalId} onChange={e => this.state.data.record.nationalId = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">تلفن</label>
                                            <input defaultValue={this.state.data.record.phone} onChange={e => this.state.data.record.phone = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">تاریخ درخواست</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.date = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">هزینه خدمات</label>
                                            <input defaultValue={this.state.data.record.servicePrice} onChange={e => this.state.data.record.servicePrice = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نام آزمایشگاه</label>
                                            <input defaultValue={this.state.data.record.labName} onChange={e => this.state.data.record.labName = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <textarea defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" style={{"height": "80px","min-height": "80px"}}></textarea>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}